// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"eed5a7a27e433e5cc88b","691":"7d52c156397e8a53a9c5"}[chunkId] + ".js";
};